import * as z from 'zod'

export enum LinkTypes {
	user = `user`,
	link = `link`,
}

export const LinkSchema = z.object({
	_id: z.any().optional(),
	link: z.string().nonempty(),
	targetType: z.nativeEnum(LinkTypes),
	targetId: z.string().nonempty().optional(),
	targetUrl: z.string().nonempty().optional(),
	active: z.boolean(),
}).superRefine((data, ctx) => {
	if (!data.targetId && !data.targetUrl) {
		ctx.addIssue({
			code: `custom`,
			message: `Either targetId or targetUrl should be provided`,
		})
	}
	if (data.targetId && data.targetUrl) {
		ctx.addIssue({
			code: `custom`,
			message: `Only one of targetId or targetUrl should be provided`,
		})
	}
})

export type LinkType = z.TypeOf<typeof LinkSchema>